export default "__VITE_ASSET__Bb56Wda5__"